<div class="row col-12 p-0 m-0 main-page-section">
  <div class="col-12 p-0 companies-section">
    <!-- <app-header></app-header> -->
    <div class="col-height">
      <div>
        <div class="breadcrumbs-section padding-left">
          <span class="prev-page pt-1 "><a routerLink="/overview">Home</a></span>
          <img class="separator pl-2 pr-2" src="../../../assets/images/seperator.png">
          <span class="prev-page pt-1 "><a routerLink="/meeting-room/view-meeting-room">Meeting Rooms</a></span>
          <img class="separator pl-2 pr-2" src="../../../assets/images/seperator.png"
            *ngIf="HeaderMeetingRoomName!==undefined">
          <span class="curr-page  breadcrumbs-section-font">{{HeaderMeetingRoomName}}</span>
        </div>
      </div>

      <form class="property-layout" #myForm="ngForm" enctype="multipart/form-data">

        <div class="row">
          <div class="col-9">
            <h1>{{HeaderMeetingRoomName}}</h1>
          </div>
          <div class="row">
            <div class="col-3">
              <button type="button" (click)="save($event, myForm)">{{buttonType}}</button>
            </div>
          </div>
        </div>

        <div class="field-error mt-2" *ngIf="inValidText!==''">{{inValidText}}</div>

        <!-- Meeting Room type -->

        <div class="row mt-3">
          <div class="col-12 text">
            Zone
          </div>
        </div>
        <div class="row">
          <div class="col-1">
            <input class="mt-3" style="cursor: pointer;" [checked]="zoneVal=='sez'"
              (click)="selectZone($event.target.value)" name="zone" value="sez" type="radio"><span
              class="pl-2 radio-text">SEZ</span>
          </div>
          <div class="col-2">
            <input class="mt-3" style="cursor: pointer;" [checked]="zoneVal=='nonSez'"
              (click)="selectZone($event.target.value)" name="zone" value="nonSez" type="radio"><span
              class="pl-2 radio-text">Non-SEZ</span>
          </div>
        </div>

        <div class="input-set">

          <!-- Meeting Room name -->
          <div class="row">
            <div class="col-12">
              <input type="text" [ngClass]="propertyName?'textbox-onselect':'textbox-style'"
                class="search-line  pl-4 placeholder-text mt-4" [placeholder]="!propertyName ? 'Room Name' : ''"
                (click)="enterName('propertyName')" (blur)="enterName('propertyName')" value={{roomName}}
                [(ngModel)]="roomName" name="FName" #fName="ngModel" required>
              <label *ngIf="propertyName" class="form-lable-email">Room Name</label>
              <div *ngIf="fName.invalid && (fName.dirty || fName.touched ||showError)" class="field-error pl-2"> <span
                  *ngIf="fName.errors?.required">* This field is Mandatory</span>
              </div>
            </div>
          </div>


          <!-- image upload -->
          <div
            *ngIf="this.TempMeetingRoomImages.length==0 || this.TempMeetingRoomImages.length==null || this.TempMeetingRoomImages.length==undefined"
            class="image-border ml-0 pl-0 mt-5">
            <div class="file-upload">
              <label for="upload-photo"><img src="../../../assets/images/cityUpload.png"> Upload Image
                <p class="mt-3">Format:JPG, JPEG and PNG images | Dimension: 1080 px X 608 px |Size : 2Mb</p>
              </label>
              <input type="file" name="meetingRoomImages" (change)="onSelectFile($event)" accept="image/png, image/jpeg, image/jpg" id="upload-photo" />
            </div>
          </div>

          <div *ngIf="this.TempMeetingRoomImages.length>0" class="image-border ml-0 pl-0 mt-4">
            <img [src]="this.TempMeetingRoomImages[0].imageURL">
            <img class="delete-icon" (click)="delete(TempMeetingRoomImages[0],TempMeetingRoomImages[0].imageId,0)"
              src="../../../assets/images/park-info/delete.png">
          </div>

          <div class="row">
            <div [ngClass]="(this.TempMeetingRoomImages[3]==undefined)?'col-2 mr-4':'col-0 mr-0'">
              <div class=" image-border-small ml-0 pl-0 mt-5" *ngIf="this.TempMeetingRoomImages[3]==undefined">
                <label for="upload-photo"><img class="icon" src="../../../assets/images/add.png"> Add
                  {{4-TempMeetingRoomImages.length}}
                  more images
                </label>
                <input type="file" name="meetingRoomImages" (change)="onSelectFile($event)" style="display: none;" accept="image/png, image/jpeg, image/jpg"
                  id="upload-photo" />
              </div>
            </div>

            <div class="col-2 mr-4 ml-2" *ngFor="let item of TempMeetingRoomImages|slice:1:4;let i=index;">
              <div class=" image-small ml-0 pl-0 mt-5 mr-2">
                <img [src]="item.imageURL">
                <img class="delete-icon" (click)="delete(item,item.imageId,i+1)"
                  src="../../../assets/images/park-info/delete.png">
              </div>
            </div>
          </div>
          <hr>

          <!-- Description -->
          <div class="about" #descriptionmeetingroom>
            <div class="row">
              <div class="col-12">
                <p class="text">Description</p>
                <p>Write a small description about the meeting room giving users an overview.</p>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <textarea autosize type="text" class="input-content" row="1" required [(ngModel)]="description"
                  name='des' #des="ngModel"></textarea>
                <div *ngIf="des.invalid && (des.dirty || des.touched || showError)" class="field-error pl-2">
                  <span *ngIf="des.errors?.required">* This field is Mandatory</span>
                </div>
              </div>
            </div>
          </div>

          <!--Minimun Booking Time-->
          <div>

            <div class="row" style="margin-top: 40px;padding-left: 15px;">
              <p class="" style="font-size: 20px;color: rgba(64,64,64,0.6);">Mark as Free</p>
              <label class="switch" style="position: relative;margin-left: 2%;">
                <input name="isRoomFree" [(ngModel)]="isRoomFree" (change)="markAsFreeOrPaid($event)" type="checkbox"
                  class="custom-control-input" id="customSwitches" />
                <span class="slider round"></span>
              </label>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="row">
                  <div class="col-12 text mt-3">Minimum Booking Duration (in Hours)
                    <!-- <img style="cursor: pointer;"
                      (mouseover)="togglePopup(p3)" (mouseout)="togglePopup(p3)" [ngbPopover]="popContentMin"
                      [popoverTitle]="popTitle" triggers="manual" #p3="ngbPopover" loading="lazy"
                      src="../../../assets/images/Button - Info Copy.png"> -->
                    <ng-template #popContentMin let-greeting="greeting">
                      <div>Minimum Booking Duration (Hours)</div>
                    </ng-template>
                  </div>
                  <div class="col-1"></div>
                  <div class="col-1"></div>
                  <!-- <div class="col-1- pt-2" style="margin-left: -70px;">
                      <label class="switch">
                        <input type="checkbox" id="booking" [checked]='minBookingDurationVal' [value]='minBookingDurationVal'
                          (change)="toggle('booking',minBookingDurationVal)">
                        <span class="slider round"></span>
                      </label>
                    </div> -->
                  <div class="col-1"></div>
                </div>
                <div class="row text ml-2 mt-3">
                  <div class="col-5 value-setter d-flex">
                    <button type="submit" [disabled]="minbookingDuration<=0.5"
                      (click)="setminDurationVal(-0.5)">-</button>
                    <input class="input" type="number" [(ngModel)]="minbookingDuration" name='minbookingDuration'
                      readonly="true">
                    <button type="submit" (click)="setminDurationVal(0.5)">+</button>
                  </div>
                  <div class="col-7"></div>
                </div>
              </div>
              <div class="col-2"></div>
            </div>

            <div class="row row-gap-4">
              <div class="col-12 text pt-3">
                Operation Days
              </div>
              <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                <div class="form-group floating_form_field mb-0 w-100">
                  <select class="form-control" name="FOperation" #fOperation="ngModel" [(ngModel)]="fromDaysOperation"
                    required>
                    <option value="">From</option>
                    <option value="{{dayf.id}}" *ngFor="let dayf of daysOfOperation">{{dayf.name}}
                    </option>
                  </select>
                  <label>From</label>
                </div>
                <div *ngIf="fOperation.dirty || fOperation.touched || showError" class="field-error pl-2"> <span
                    *ngIf="fOperation.errors?.required">* This field is
                    Mandatory</span>
                </div>
              </div>

              <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                <div class="form-group floating_form_field mb-0 w-100">
                  <select class="form-control" name="TOperation" #tOperation="ngModel" [(ngModel)]="toDaysOperation"
                    required>
                    <option value="">To</option>
                    <option value="{{dayt.id}}" *ngFor="let dayt of daysOfOperation">{{dayt.name}}
                    </option>
                  </select>
                  <label>To</label>
                </div>
                <div *ngIf="tOperation.invalid && (tOperation.dirty || tOperation.touched || showError)"
                  class="field-error pl-2"> <span *ngIf="tOperation.errors?.required">* This field is
                    Mandatory</span>
                </div>
              </div>
            </div>

          </div>
          <hr>
          <!--End of Minimum Booking Time-->

          <!-- rate card -->
          <div>
            <div class="row mt-3 mb-5">
              <div class="col-12 text">
                Rate Card
              </div>
            </div>


            <!-- <div class="row mt-4">
                <div class="col-1 text-small pt-3 ">
                  Hourly
                </div>
                <div class="col-2" style="margin-left: -30px;">
                  <input type="number" [ngClass]="hourRate?'textbox-onselect-small':'textbox-style-small'"
                    class="search-line  pl-4 placeholder-text" [placeholder]="!hourRate ? 'Rate' : ''"
                    [(ngModel)]="hourRate" name='hourRate' (click)="enterName('hourRate')" value={{hourRate}}>
                  <label *ngIf="hourR" class="form-lable-email">Rate</label>
                  <span *ngIf="hourR" class="rupee-icon">₹</span>
                </div>
                <div class="col-2 ml-5">
                  <input type="number" [ngClass]="hourAdditional?'textbox-onselect-small':'textbox-style-small'"
                    class="search-line  pl-4 placeholder-text"
                    [placeholder]="!hourAdditional ? 'Additional hour rate' : ''" (click)="enterName('hourAdditional')"
                    [(ngModel)]="hourAdditional" name='hourAdditional' value={{hourAdditional}}>
                  <label *ngIf="hourAdd" class="form-lable-email">Additional hour rate</label>
                  <span *ngIf="hourAdd" class="rupee-icon">₹</span>
                </div>
              </div> -->

            <!-- <div class="row mt-3"> -->

            <div class="row mt-5" *ngFor="let item of TempRateCardHourCal;let i=index">

              <div class="col-1 text-small pt-3">
                Hourly
              </div>

              <div class="col-2">
                <input type="number" [readOnly]="isParkRoomFreePaid"
                  [ngClass]="hourRate?'textbox-onselect-small':'textbox-style-small'"
                  class="search-line  pl-4 placeholder-text w-100" [placeholder]="!hourR ? 'Rate' : ''"
                  [(ngModel)]="TempRateCardHourCal[i].hourRate" name='hourRate{{i}}'
                  (click)="enterNameRateCard('hourRate',i)" (keyup)="checkhourRateValue(TempRateCardHourCal, i)"
                  required pattern="^[0-9]*$" (keypress)="validateNumber($event)">
                <label *ngIf="hourR" class="form-lable-email">Rate</label>
                <span *ngIf="hourR" class="rupee-icon">₹</span>
                <div *ngIf="error[item.hourRate+i] && !isParkRoomFreePaid" class="field-error">
                  <span>* This field is Mandatory</span>
                </div>
              </div>

              <div class="col-2" style="position: relative;" (clickOutside)="onClickedOutside($event)"
                [autoClose]="'outside'" [ngbPopover]="popupcontent" triggers="manual" #p6="ngbPopover"
                (click)="openPopoverRateCard(p6, TempRateCardHourCal, i)" placement="bottom"
                popoverClass='starttime-popover'>
                <input type="text" class="textbox-style-small-dropdown pl-3 pointer-link w-100"
                  [placeholder]="!stimeratePlaceHolder ? 'Start Time' : ''" name="stimerate{{i}}"
                  [(ngModel)]="TempRateCardHourCal[i].stimerate" (click)="enterName('stimeratePlaceHolder')"
                  (mouseleave)="checkHourTimeWithDay()" (mouseenter)="checkHourTimeWithDay()" readonly>
                <label *ngIf="stimeratePlaceHolder" class="form-lable-email">Start Time</label>
                <ng-template #popupcontent let-data="data">
                  <div class="rectangle-copy-5">
                    <div class="pl-3 pr-4 pt-1" (mouseleave)="checkHourTimeWithDay()"
                      (mouseenter)="checkHourTimeWithDay()">
                      <ngb-timepicker name="strtTime" [meridian]="meridian" [(ngModel)]="startTimeRate"
                        (ngModelChange)="onTimeChangeRateCard($event, i)" [minuteStep]="15"
                        (mouseleave)="checkHourTimeWithDay()" (mouseenter)="checkHourTimeWithDay()"
                        [readonlyInput]="true">
                      </ngb-timepicker>
                      <div class="toggle-position1">
                        <label class="switch1">
                          <input #saveamorpmCheckBoxRate type="checkbox" id="saveamorpmCheckBoxRate" [checked]="amorpm2"
                            (change)="toggleAmPmSelectionRate(saveamorpmCheckBoxRate.checked, i)">
                          <span class="bookslider1"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <div *ngIf="error[item.stimerate+i]" class="field-error">
                  <span>* This field is Mandatory</span>
                </div>
              </div>

              <div class="col-2" style="position: relative;" (clickOutside)="onClickedOutside($event)"
                [autoClose]="'outside'" [ngbPopover]="popContent4" triggers="manual" #p7="ngbPopover"
                (click)="openPopoverRateCardEndTime(p7, TempRateCardHourCal, i)" placement="bottom"
                popoverClass='starttime-popover'>
                <input type="text" class="textbox-style-small-dropdown pl-3 pointer-link w-100"
                  [placeholder]="!etimeratePlaceHolder ? 'End Time' : ''" name="etimerate{{i}}"
                  [(ngModel)]="TempRateCardHourCal[i].etimerate" (click)="enterName('etimeratePlaceHolder')"
                  (mouseleave)="checkHourTimeWithDay()" (mouseenter)="checkHourTimeWithDay()" readonly>
                <label *ngIf="etimeratePlaceHolder" class="form-lable-email">End Time</label>
                <ng-template #popContent4>
                  <div class="rectangle-copy-5">
                    <div class="pl-3 pr-4 pt-1 ">
                      <ngb-timepicker name="edTimeRate" [meridian]="meridian" [(ngModel)]="endTimeRate"
                        (ngModelChange)="onTimeChangeRate1($event, i)" [minuteStep]="15"
                        (mouseleave)="checkHourTimeWithDay()" (mouseenter)="checkHourTimeWithDay()"
                        [readonlyInput]="true"></ngb-timepicker>
                      <div class="toggle-position1">
                        <label class="switch1">
                          <input #saveamorpmCheckBoxRate1 type="checkbox" id="saveamorpmCheckBoxRate1"
                            [checked]="amorpm3" (change)="toggleAmPmSelectionRate1(saveamorpmCheckBoxRate1.checked, i)">
                          <span class="bookslider1"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <div *ngIf="error[item.etimerate+i]" class="field-error">
                  <span>* This field is Mandatory</span>
                </div>
              </div>


              <div class="col-1" *ngIf="i!=0"><button (click)="deleteMultipleRate(i)" class="delete-tnc"><img
                    src="../../../assets/images/delete_black_24dp copy 4.png"></button></div>
              <div class="col-2"></div>
            </div>

            <div *ngIf="!isParkRoomFreePaid" class="col-1" style="position: relative;"><button class="add-more-button"
                (click)="addMultipleRate()">+
                Add more</button>
            </div>
            <!-- </div> -->

            <div class="row mb-5 mt-3">
              <div class="col-1 text-small pt-3">
                Daily
              </div>

              <div class="col-2">

                <input type="number" [readOnly]="isParkRoomFreePaid" pattern="^[0-9]*$"
                  (keypress)="validateNumber($event)"
                  [ngClass]="dailyRate?'textbox-onselect-small':'textbox-style-small'"
                  class="search-line  pl-4 placeholder-text w-100" [placeholder]="!dailyRate ? 'Rate' : ''"
                  [(ngModel)]="dailyRate" name='dailyRate' (click)="enterName('dailyRate')" value={{dailyRate}}>
                <label *ngIf="dailyR" class="form-lable-email">Rate</label>
                <span *ngIf="dailyR" class="rupee-icon">₹</span>
                <div *ngIf="errDailyRate && showError" class="field-error pl-2">
                  <span>* This field is Mandatory</span>
                </div>

              </div>

              <div class="col-2">
                <input type="number" [readOnly]="isParkRoomFreePaid" pattern="^[0-9]*$"
                  (keypress)="validateNumber($event)"
                  [ngClass]="dailyAdditional?'textbox-onselect-small':'textbox-style-small'"
                  class="search-line  pl-4 placeholder-text w-100"
                  [placeholder]="!dailyAdditional ? 'Additional day rate' : ''" (click)="enterName('dailyAdditional')"
                  [(ngModel)]="dailyAdditional" name='dailyAdditional' value={{dailyAdditional}}>
                <label *ngIf="dailyAdd" class="form-lable-email">Additional day rate</label>
                <span *ngIf="dailyAdd" class="rupee-icon">₹</span>
                <div *ngIf="errDailyAdditional && showError" class="field-error pl-2">
                  <span>* This field is Mandatory</span>
                </div>
              </div>

              <div class="col-2" style="position: relative;" (clickOutside)="onClickedOutside($event)"
                [autoClose]="'outside'" [ngbPopover]="popContent1" triggers="manual" #p1="" (click)="openPopover(p1)"
                placement="bottom" popoverClass='starttime-popover'>
                <input type="text" class="textbox-style-small-dropdown pl-3 pointer-link w-100"
                  [placeholder]="!time1 ? 'Start Time' : ''" readonly [(ngModel)]="startTimePlaceholder" disabled
                  required name="stime" name='startTimePlaceholder' #stime=ngModel>

                <div class="form-lable-email">Start Time</div>

                <ng-template #popContent1>
                  <div class="rectangle-copy-5">

                    <div class="pl-3 pr-4 pt-1">
                      <ngb-timepicker name="strtTime" [meridian]="meridian" [readonlyInputs]=true
                        [(ngModel)]="startTime" (ngModelChange)="onTimeChange($event)" [minuteStep]="15">
                      </ngb-timepicker>

                      <div class="toggle-position1">
                        <label class="switch1">
                          <input #saveamorpmCheckBox type="checkbox" id="saveamorpmCheckBox" [checked]="amorpm"
                            (change)="toggleAmPmSelection(saveamorpmCheckBox.checked)">
                          <span class="bookslider1"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>

              <div class="col-2 " style="position: relative;" (clickOutside)="onClickedOutside($event)"
                [autoClose]="'outside'" [ngbPopover]="popContent" triggers="manual" #p2="" (click)="openPopover(p2)"
                placement="bottom" popoverClass='starttime-popover'>
                <input type="text" class="textbox-style-small-dropdown pl-3 pointer-link w-100" readonly disabled
                  [placeholder]="!time2 ? 'End Time' : ''" [(ngModel)]="endTimePlaceholder" required name="etime"
                  name='endTimePlaceholder' #etime=ngModel>

                <div class="form-lable-email">End Time</div>
                <ng-template #popContent>
                  <div class="rectangle-copy-5">
                    <div class="pl-3 pr-4 pt-1 ">
                      <ngb-timepicker name="endTime" [meridian]="meridian" [(ngModel)]="endTime" [readonlyInputs]=true
                        (ngModelChange)="onTimeChange1($event)" [minuteStep]="15"></ngb-timepicker>

                      <div class="toggle-position1">
                        <label class="switch1">
                          <input #saveamorpmCheckBox1 type="checkbox" id="saveamorpmCheckBox1" [checked]="amorpm1"
                            (change)="toggleAmPmSelection1(saveamorpmCheckBox1.checked)">
                          <span class="bookslider1"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>

          <hr>

          <!-- Meeting room and booking capacity -->

          <div>
            <div class="row">
              <div class="col-4">
                <div class="row">
                  <div class="col-8 text">Capacity <img style="cursor: pointer;" (mouseover)="togglePopup(p10)"
                      (mouseout)="togglePopup(p10)" [ngbPopover]="popContent10" [popoverTitle]="popTitle"
                      triggers="manual" #p10="ngbPopover" loading="lazy"
                      src="../../../assets/images/Button - Info Copy.png">
                    <ng-template #popContent10 let-greeting="greeting">
                      <div>Indicates the maximum number of people the room can accommodate.</div>
                    </ng-template>
                  </div>
                  <!-- <div class="col-1"></div>
                  <div class="col-1"></div> -->
                  <div class="col-1- pt-2" style="margin-left: -70px;">
                    <label class="switch">
                      <input type="checkbox" id="booking" [checked]='bookingCapaciltyVal' [value]='bookingCapaciltyVal'
                        (change)="toggle('booking',bookingCapaciltyVal)">
                      <span class="slider round"></span>
                    </label>
                  </div>
                  <div class="col-1"></div>
                </div>
                <div class="row text ml-2" *ngIf="showBooking">
                  <div class="col-5 value-setter d-flex">
                    <button type="submit" [disabled]="capacity<=1" (click)="setbookingVal(-1)">-</button>
                    <input class="input" type="number" [(capacity)]="hourRate" [(ngModel)]="capacity" name='capacity'
                      min="1" (input)="onInput($event)">
                    <button type="submit" (click)="setbookingVal(1)">+</button>
                  </div>
                  <div class="col-7"></div>
                </div>
              </div>
              <div class="col-2"></div>
            </div>
          </div>
          <hr>

          <div class="amenities">
            <div class="row">
              <div class="col-12">
                <p>Amenities</p>
              </div>
            </div>

            <div class="row m-0">
              <div class="col-10">
                <button *ngFor="let item of amentities"
                  [ngClass]="(selectedAminity.includes(item.amenitiesId))?'button-onselect':'button-before'"
                  (click)="addAmentity(item)" class="mr-2 mb-3" type="submit">
                  <img class="icon" src={{item.imageURL}}>
                  {{item.amenityName}}
                  <img *ngIf="selectedAminity.includes(item.amenitiesId)" src="/assets/images/cross-mark.png">
                </button>
              </div>
              <div class="col-2"></div>
            </div>
          </div>

          <hr *ngIf="!isParkRoomFreePaid">
          <!-- calculation and policies -->
          <div *ngIf="!isParkRoomFreePaid">
            <div class="row">
              <div class="col-12 text">
                Cancellation & Refund
              </div>
            </div>
            <div class="row mt-4 checkbox">
              <div class="col-2"><input type="radio" [checked]="true" style="display: none;" id="cal" value="cal"
                  name="typ" (click)="selectType($event)"><label [ngClass]="type=='cal'?'checked':'check'"
                  for="cal">Calculation</label></div>
              <div class="col-2"><input type="radio" style="display: none;" id="pol" value="pol" name="typ"
                  (click)="selectType($event)"><label [ngClass]="type=='pol'?'checked':'check'"
                  for="pol">Policies</label>
              </div>
            </div>
            <div class="row">
              <div class="col-10" style="position: inherit; margin-top: -25px;">
                <hr>
              </div>
              <div class="col-2"></div>
            </div>

            <div class="row" *ngIf="showPolicy">

              <p class="text-small pl-3">* Please ensure the cancellation policy aligns with the data entered in the
                calculation tab,</p>

              <div class="col-12 title-text">
                <div class="row" *ngFor="let item of TempMeetingRoomPolicies;let i=index">
                  <div class="col-9 mt-3">
                    <textarea autosize rows="1" class="input-content-1" value={{item.policyDescription}}
                      [(ngModel)]="item.policyDescription" name="policy{{i}}" [required]="!isRoomFree"></textarea>
                    <span class="count">{{i+1}}.</span>
                  </div>
                  <div class="col-1" *ngIf="i!=0"><button (click)="deletePolicy(i)" class="delete-tnc"><img
                        src="../../../assets/images/delete_black_24dp copy 4.png"></button></div>
                  <div class="col-2"></div>
                </div>
                <button class="add-more-button ml-0 p-0" *ngIf="TempMeetingRoomPolicies.length<5"
                  (click)="addPolicy()">+
                  Add
                  more</button>
              </div>
            </div>

            <div *ngIf="showCal">
              <div class="row mt-3" *ngFor="let item of TempMeetingRoomCanCal;let i=index">
                <div class="col-2">
                  <div>
                    <div style="position: relative;">
                      <div [autoClose]="'outside'" [ngbPopover]="popContentFullName" triggers="manual" #pn="ngbPopover"
                        (click)="openPopover(pn);enterName('unitType')" placement="bottom"
                        popoverClass='dash-popover dashboard-popover'>
                        <input
                          class="pt-3 pb-3 pl-4 input-width placeholder-text pointer-link textbox-style-small-dropdown w-100"
                          [placeholder]="!unitType ? 'Unit Type' : ''" readonly
                          [(ngModel)]="TempMeetingRoomCanCal[i].unitType" name="unitType_{{i}}" required>
                        <label *ngIf="unitType" class="form-lable-email">Unit Type</label>
                        <img src="/assets/images/down-arrow.png" class="dropdown-icon" loading="lazy" />
                      </div>
                    </div>
                  </div>

                  <ng-template #popContentFullName>
                    <div class="dashboard-popover">
                      <div class="d-flex justify-content-between">
                        <div class="pl-3 pt-3 pr-3 pb-3 ">
                          <div class="row pb-2" *ngFor="let item of unitTypeList;let index =i"
                            (click)="setUnitType(item,i); openPopover(pn);">
                            <div class="popover-content normal-font pl-3 email-width" style="cursor: pointer;">
                              {{item.facilityUnitType|titlecase}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </div>

                <div class="col-2">
                  <input [readOnly]="isParkRoomFreePaid" [ngClass]="min?'textbox-onselect-small':'textbox-style-small'"
                    class="search-line  pl-4 placeholder-text w-100"
                    [placeholder]="!min ? 'No. of '+ item.unitType +' prior' : ''" [(ngModel)]="item.timePrior"
                    name="timePrior{{i}}" (click)="enterName('min')" type="text" required>
                  <label *ngIf="min" class="form-lable-email">No. of {{item.unitType}} prior</label>

                  <div *ngIf="error[item.timePrior+i] && !isParkRoomFreePaid" class="field-error">
                    <span>* This field is Mandatory</span>
                  </div>
                </div>

                <div class="col-3">
                  <input type="number" [readOnly]="isParkRoomFreePaid" pattern="^[0-9]*$"
                    (keypress)="validateNumber($event)"
                    [ngClass]="amtDeducted?'textbox-onselect-small':'textbox-style-small'"
                    class="search-line  pl-4 placeholder-text w-100" value={{item.amountDeducted}}
                    [(ngModel)]="item.amountDeducted" name="amountDeducted{{i}}" required
                    [placeholder]="!amtDeducted ? 'Amount Deducted (in %)' : ''" (click)="enterName('amtDeducted')">
                  <label *ngIf="amtDeducted" class="form-lable-email">Amount Deducted (%)</label>
                  <div *ngIf="error[item.amountDeducted+i] && !isParkRoomFreePaid" class="field-error">
                    <span>* This field is Mandatory</span>
                  </div>
                </div>

                <div class="col-1" *ngIf="i!=0"><button (click)="deleteCalc(i)" class="delete-tnc"><img
                      src="../../../assets/images/delete_black_24dp copy 4.png"></button></div>
                <div class="col-2"></div>
              </div>
              <button class="add-more-button p-0 ml-0" *ngIf="TempMeetingRoomCanCal.length<5 && !isParkRoomFreePaid"
                (click)="addCalc()">+ Add
                more</button>
            </div>
          </div>
          <hr>

          <!-- Maintainace days -->

          <div class="mb-4">
            <div class="row">
              <div class="col-12 text">
                Maintenance Day(s)
              </div>
            </div>
            <!-- <div class="row mt-4">
                <div class="col-1">
                  <input class="cal-icon" autocomplete="off" (click)="d1.toggle()" (keypress)="$event.preventDefault()"
                    (dateSelect)="updateSelectedDate($event)" id="owner-dob" type="text" name="dp1" ngbDatepicker
                    #d1="ngbDatepicker" [minDate]="minDate" required readonly>
                </div>
                <div class="col-2 pt-2">
                  <div class="text-small">Start Date</div>
                  <span class="title-text">{{formatDate}}</span>
                </div>
  
                <div class="col-1">
                  <input class=" cal-icon" autocomplete="off" (click)="d2.toggle()" (keypress)="$event.preventDefault()"
                    (dateSelect)="updateSelectedToDate($event)" id="owner-dob" type="text" name="dp1" ngbDatepicker
                    #d2="ngbDatepicker" [minDate]="minDate" required readonly>
  
                </div>
                <div class="col-2">
                  <div class="text-small pt-2">End Date</div>
                  <span class="title-text">{{formatToDate}}</span>
                </div>
              </div> -->
          </div>


          <!-- Maintainace days -->
          <div class="maintainace-sec">
            <div class="row row-gap-4 mt-5">
              <div class="col-md-3">
                <div class="form-group floating_form_field mb-0 w-100">
                  <input class="form-control w-100" autocomplete="off" (click)="d6.toggle()"
                    [placeholder]="!mtsDate ? 'Start Date' : ''" (clickOutside)="onClickedOutside($event)"
                    [autoClose]="'inside'" (keypress)="$event.preventDefault()"
                    (dateSelect)="updateSelectedDateMaintennance($event)" id="maintananceStarDateTime" type="text"
                    name="maintananceStarDateTime" #sMaintenanceDate="ngModel" [(ngModel)]="startDateOfMaintenance"
                    ngbDatepicker container='body' #d6="ngbDatepicker" [minDate]="minDate">
                  <label>Start Date</label>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group floating_form_field mb-0 w-100">
                  <input class="form-control w-100" autocomplete="off" (click)="d7.toggle()"
                    [placeholder]="!mteDate ? 'End Date' : ''" (clickOutside)="onClickedOutside($event)"
                    [autoClose]="'inside'" (keypress)="$event.preventDefault()"
                    (dateSelect)="updateSelectedToDateMaintennance($event)" id="maintananceEndDateTime" type="text"
                    name="maintananceEndDateTime" #eMaintenanceDate="ngModel" [(ngModel)]="endDateOfMaintenance"
                    ngbDatepicker container='body' #d7="ngbDatepicker" [minDate]="minDate">
                  <label>End Date</label>
                </div>
              </div>
            </div>

            <div class="row row-gap-4 mt-4">
              <div class="col-auto">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input w-auto" name="isAllDay" id="all_day"
                    [(ngModel)]="isAllDay" (change)="allDayCheckTime($event)">
                  <label class="custom-control-label cursor-pointer w-auto" for="all_day">All day</label>
                </div>
              </div>
            </div>

            <div class="row row-gap-4 mt-4">
              <div class="col-12 col-md-6 col-lg-3 d-flex flex-column row-gap-1">
                <div class="form-group floating_form_field mb-0 w-100">
                  <select class="form-control" (change)="onSelected($event)" name="repeatMode" id="repeatMode"
                    #dailyOperation="ngModel" [(ngModel)]="repeatEvery">
                    <option value="{{repeat.id}}" *ngFor="let repeat of theMethodOfRepete">{{repeat.name}}</option>
                  </select>
                  <label>Repeat</label>
                </div>
              </div>

              <div class="col-12 col-md-6 col-lg-4"
                *ngIf="selectedDaily || selectedWeekly || selectedMonthly || selectedYearly">
                <div class="row">
                  <div class="col-12 col-md-6 col-lg-5">
                    <div class="value-setter d-flex">
                      <button type="submit" [disabled]="repeatEveryType<=1"
                        (click)="setDurationValForMaintenance(-1)">-</button>
                      <input type="number" #typeOfRepeat="ngModel" [(ngModel)]="repeatEveryType"
                        id="repeatModeEveryCount" name="repeatModeEveryCount" [step]="stepRepeat" [min]="minRepeat"
                        [max]="maxRepeat" class="input" [placeholder]="!repeateTestPlaceHolder ? 'Repeat every' : ''"
                        (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'" readonly="true">
                      <button type="submit" [disabled]="repeatEveryType>=maxRepeat"
                        (click)="setDurationValForMaintenance(1)">+</button>
                      <label class="but-label">Repeat Every</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="smalltext"><small>{{this.repeatEveryText}}</small></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="selectweek mt-4" *ngIf="selectedWeekly">
              <div class="row">
                <div class="col-12 col-md-6 col-lg-3 d-flex flex-column row-gap-1">
                  <label class="custom-rep-label">Repeat On</label>
                  <div class="d-flex row-gap-1">
                    <div class="custom-control custom-checkbox mr-3"
                      *ngFor="let dayfweek of weeksOfOperation;let i=index">
                      <input type="checkbox" class="custom-control-input w-auto" name="repeatWeeksOn"
                        value="{{dayfweek.id}}" id="{{dayfweek.name}}" [checked]="dayfweek.selected"
                        (change)="toggleSelection(dayfweek)">
                      <label class="custom-control-label cursor-pointer w-auto"
                        for="{{dayfweek.name}}">{{dayfweek.name}}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="selectmonth mt-4" *ngIf="selectedMonthly">
              <div class="row">
                <div class="col-12 col-md-6 col-lg-3 d-flex flex-column row-gap-1">
                  <div class="smalltext w-auto mb-3 h-auto"><small>Repeat On</small></div>
                  <div class="d-flex align-items-center column-gap-2">
                    <div class="custom-control custom-radio flex-shrink-0">
                      <input type="radio" class="custom-control-input w-auto" value="1" id="MonthDayRd"
                        name="isRepeatOnDay" [checked]="monthlyRepeatOnChecked" #monthhlyRptChk="ngModel"
                        [(ngModel)]="monthlyRepeateOnModel">
                      <label for="MonthDayRd"
                        class="custom-control-label cursor-pointer font-weight-semibold text-gray-medium"></label>
                    </div>
                    <div class="form-group floating_form_field mb-0 w-100">
                      <div class="form-group floating_form_field mb-0 w-100">
                        <select class="form-control" name="repeatOnDay" id="repeatOnDay" #monthDateValueId="ngModel"
                          [(ngModel)]="monthDateValueModel">
                          <option value="{{dateofmonth.name}}" *ngFor="let dateofmonth of monthAllDate;let i=index">
                            {{dateofmonth.name}}</option>
                        </select>
                        <label>Select Date</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-12 col-md-6 col-lg-3 d-flex flex-column row-gap-1">
                  <div class="d-flex align-items-center column-gap-2">
                    <div class="custom-control custom-radio flex-shrink-0">
                      <input type="radio" class="custom-control-input w-auto" value="2" id="WeekdayRd"
                        name="isRepeatOnDay" [checked]="monthlyRepeatOnCheckedWeekName" #monthhlyRptChk="ngModel"
                        [(ngModel)]="monthlyRepeateOnModel">
                      <label for="WeekdayRd"
                        class="custom-control-label cursor-pointer font-weight-semibold text-gray-medium"></label>
                    </div>
                    <div class="form-group floating_form_field mb-0 w-100">
                      <select class="form-control" [(ngModel)]="monthlyRepeateOnWeekStarting"
                        #weekNameForMontlySrt="ngModel" name="weekNumber" id="weekNumber">
                        <option value="{{mstpt.id}}" *ngFor="let mstpt of monthSratingPoint">{{mstpt.name}}</option>
                      </select>
                      <label>Select Every</label>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-2 d-flex flex-column row-gap-1">
                  <div class="form-group floating_form_field mb-0 w-100">
                    <select class="form-control" [(ngModel)]="monthlyRepeateOnWeekName" #weekNameForMontlyRpt="ngModel"
                      name="weekDay" id="weekDay">
                      <option value="{{mtdayname.id}}" *ngFor="let mtdayname of daysOfOperation">{{mtdayname.name}}
                      </option>
                    </select>
                    <label>Select Day</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="selectyear mt-4" *ngIf="selectedYearly">
              <div class="row">
                <div class="col-12 col-md-6 col-lg-3 d-flex flex-column row-gap-1">
                  <div class="smalltext w-auto mb-3 h-auto"><small>Repeat On</small></div>
                  <div class="d-flex align-items-center column-gap-2">
                    <div class="form-group floating_form_field mb-0 w-100">
                      <select class="form-control" name="repeatMonth" id="repeatMonth" #repeatMonthSelectValue="ngModel"
                        [(ngModel)]="monthsOfOperationModel">
                        <option value="{{optMonth.id}}" *ngFor="let optMonth of monthsOfOperation;let i=index">
                          {{optMonth.name}}</option>
                      </select>
                      <label>Select Month</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-12 col-md-6 col-lg-3 d-flex flex-column row-gap-1">
                  <div class="d-flex align-items-center column-gap-2">
                    <div class="custom-control custom-radio flex-shrink-0">
                      <input type="radio" class="custom-control-input w-auto" value="1" id="MonthDay"
                        name="isRepeatOnDay" [checked]="monthlyRepeatOnChecked" #monthhlyRptChk="ngModel"
                        [(ngModel)]="monthlyRepeateOnModel">
                      <label for="MonthDay"
                        class="custom-control-label cursor-pointer font-weight-semibold text-gray-medium"></label>
                    </div>
                    <div class="form-group floating_form_field mb-0 w-100">
                      <select class="form-control" name="repeatOnDay" id="repeatOnDay" #monthDateValueId="ngModel"
                        [(ngModel)]="monthDateValueModel">
                        <option value="{{dateofmonth.id}}" *ngFor="let dateofmonth of monthAllDate;let i=index">
                          {{dateofmonth.name}}</option>
                      </select>
                      <label>Select Date</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-12 col-md-6 col-lg-3 d-flex flex-column row-gap-1">
                  <div class="d-flex align-items-center column-gap-2">
                    <div class="custom-control custom-radio flex-shrink-0">
                      <input type="radio" class="custom-control-input w-auto" value="2" id="Weekday"
                        name="isRepeatOnDay" [checked]="monthlyRepeatOnCheckedWeekName" #monthhlyRptChk="ngModel"
                        [(ngModel)]="monthlyRepeateOnModel">
                      <label for="Weekday"
                        class="custom-control-label cursor-pointer font-weight-semibold text-gray-medium"></label>
                    </div>
                    <div class="form-group floating_form_field mb-0 w-100">
                      <select class="form-control" [(ngModel)]="monthlyRepeateOnWeekStarting"
                        #weekNameForMontlySrt="ngModel" name="weekNumber" id="weekNumber">
                        <option value="{{mstpt.id}}" *ngFor="let mstpt of monthSratingPoint">{{mstpt.name}}</option>
                      </select>
                      <label>Select Every</label>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-2 d-flex flex-column row-gap-1">
                  <div class="form-group floating_form_field mb-0 w-100">
                    <select class="form-control" [(ngModel)]="monthlyRepeateOnWeekName" #weekNameForMontlyRpt="ngModel"
                      name="weekDay" id="weekDay">
                      <option value="{{mtdayname.id}}" *ngFor="let mtdayname of daysOfOperation">{{mtdayname.name}}
                      </option>
                    </select>
                    <label>Select Day</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="datetimesec mt-4">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group floating_form_field mb-0 w-100" (clickOutside)="onClickedOutside($event)"
                    [autoClose]="'outside'" [ngbPopover]="mstarttime" triggers="manual" #m1="ngbPopover"
                    (click)="openPopoverMaintenanceStart(m1, startTimeMaintenance)" placement="bottom"
                    popoverClass='starttime-popover'>
                    <input type="text" readonly class="form-control w-100 bg-white pointer-link"
                      [placeholder]="!time1 ? 'Start Time' : ''" [(ngModel)]="startTimePlaceholderMaint" name="mtstime"
                      [disabled]="timeFieldDisabled">
                    <ng-template #mstarttime>
                      <div class="rectangle-copy-5">
                        <div class="pl-3 pr-4 pt-1 ">
                          <ngb-timepicker name="strtTimeMaint" [meridian]="meridian" [(ngModel)]="startTimeMaintenance"
                            (ngModelChange)="onTimeChangeMaintenance($event)" [minuteStep]="15" [readonlyInputs]="true"
                            [spinners]="true">
                          </ngb-timepicker>
                          <div class="toggle-position1">
                            <label class="switch1">
                              <input #saveamorpmCheckBoxMit type="checkbox" id="saveamorpmCheckBoxMit"
                                [checked]="amorpm4"
                                (change)="toggleAmPmSelectionMaintenance(saveamorpmCheckBoxMit.checked)">
                              <span class="bookslider1"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <label>Start Time</label>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group floating_form_field mb-0 w-100" (clickOutside)="onClickedOutside($event)"
                    [autoClose]="'outside'" [ngbPopover]="mendtime" triggers="manual" #m3="ngbPopover"
                    (click)="openPopoverMaintenanceEnd(m3, endTimeMaintenance)" placement="bottom"
                    popoverClass='starttime-popover'>
                    <input type="text" readonly class="form-control w-100 bg-white pointer-link"
                      [placeholder]="!time2 ? 'End Time' : ''" [(ngModel)]="endTimePlaceholderMaint" name="mtetime"
                      [disabled]="timeFieldDisabled">
                    <ng-template #mendtime>
                      <div class="rectangle-copy-5">
                        <div class="pl-3 pr-4 pt-1 ">
                          <ngb-timepicker name="endTimeMaint" [meridian]="meridian" [(ngModel)]="endTimeMaintenance"
                            (ngModelChange)="onTimeChangeMaintenance1($event)" [minuteStep]="15"></ngb-timepicker>
                          <div class="toggle-position1">
                            <label class="switch1">
                              <input #saveamorpmCheckBoxMit1 type="checkbox" id="saveamorpmCheckBoxMit1"
                                [checked]="amorpm5"
                                (change)="toggleAmPmSelectionMaintenance1(saveamorpmCheckBoxMit1.checked)">
                              <span class="bookslider1"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <label>End Time</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr>

          <!-- TNC -->
          <div class="row mt-4">
            <div class="col-12 text">
              Terms & Conditions
            </div>
          </div>

          <div class="row" *ngFor="let item of TempMeetingRoomTnc;let i=index">
            <div class="col-9 mt-3">
              <textarea autosize rows="1" class="input-content-1" [(ngModel)]="item.termDescription" name="tnc_{{i}}"
                required></textarea>
              <span class="count">{{i+1}}.</span>
            </div>
            <div class="col-1" *ngIf="i!=0"><button (click)="deleteTnC(i)" class="delete-tnc"><img
                  src="../../../assets/images/delete_black_24dp copy 4.png"></button></div>
            <div class="col-2"></div>
            <div *ngIf="error[item.termDescription+i]" class="field-error pl-3">
              <span>* This field cannot be empty</span>
            </div>
          </div>

          <button class="add-more-button p-0 ml-0" *ngIf="TempMeetingRoomTnc.length<15" (click)="addTnc()">+ Add
            more</button>

          <hr>

          <!-- contact info -->

          <div class="contact-info">

            <div class="row">
              <div class="col-12 text">
                Contact Info
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="text-small">You can add a maximum of 5 contact details</p>
              </div>
            </div>
            <div>
              <div class="row  mt-4" *ngFor="let item of TempMeetingRoomContacts;let i=index">

                <div class="col-4 ">
                  <input type="tel" [ngClass]="mobile?'textbox-onselect':'textbox-style'"
                    class="search-line  pl-4 placeholder-text " [placeholder]="!mobile ? 'Mobile Number' : ''"
                    [(ngModel)]="item.contactNumber" name="contactNumber{{i}}" (click)="enterName('mobile')"
                    (blur)="enterName('mobile')" value={{item.contactNumber}} required>
                  <label *ngIf="mobile" class="form-lable-email">Mobile Number</label>
                  <div class="prefix" *ngIf="(item?.contactNumber?.length>0&&item?.contactNumber?.length<=10)">+91</div>
                  <div *ngIf="error[item.contactNumber+i]" class="field-error">
                    <span>* Please enter valid Mobile Number</span>
                  </div>
                </div>

                <div class="col-4">
                  <input type="email" [ngClass]="email?'textbox-onselect':'textbox-style'"
                    class="search-line  pl-4 placeholder-text " [placeholder]="!email ? 'Email-Id' : ''"
                    value=" {{item.contactEmail}} " [(ngModel)]="item.contactEmail" name="contactEmail{{i}}"
                    (click)="enterName('email')" required>
                  <label *ngIf="email" class="form-lable-emailId">Email-Id</label>
                  <div *ngIf="error[item.contactEmail+i]" class="field-error"> <span>* Please enter valid Email
                      Id</span>
                  </div>
                </div>

                <div class="col-1" *ngIf="i!=0" class="pt-3" (click)="removeContact(i)"><img
                    src="../../../assets/images/cross-mark.png"></div>
                <div class="col-4" *ngIf="TempMeetingRoomContacts.length<5">
                  <button *ngIf="i==0" type="submit" (click)="addContact()"><span class="pr-2 ">+</span>Add another
                    contact</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <ng-template #contentSecurity let-modal class="text-center">
      <div class="modal-height">
        <div class="modal-body">
          <div class="">
            <div class="text pt-3 pb-3">Are you sure, you want to {{statusText}}?</div>
            <div class="popup-line"></div>
          </div>
        </div>
        <div class="submit col-12 d-flex justify-content-end ">
          <div class="pr-3">
            <button type="button " class="cancel-button pt-3" (click)="modal.close('Save click');onCancel()"><span
                class="cancel">Cancel</span></button>
          </div>
          <button type="button " class="add-button" (click)="toggleSecurity();modal.close('Save click')"><span
              class="add">Yes</span></button>
        </div>
      </div>
    </ng-template>

    <ng-template #contentMeetingRoom let-modal class="text-center">
      <div class="modal-height">
        <div class="modal-body">
          <div class="">
            <div class="text pt-3 pb-3">Are you sure, you want to {{statusText}}?</div>
            <div class="popup-line"></div>
          </div>
        </div>
        <div class="submit col-12 d-flex justify-content-end">
          <div class="pr-3">
            <button type="button" class="cancel-button pt-3" (click)="modal.close('Save click');onCancel()"><span
                class="cancel">Cancel</span></button>
          </div>
          <button type="button" class="add-button" (click)="toggleMeetingRoom();modal.close('Save click')"><span
              class="add">Yes</span></button>
        </div>
      </div>
    </ng-template>

    <ng-template #contentBooking let-modal class="text-center">
      <div class="modal-height">
        <div class="modal-body">
          <div class="">
            <div class="text pt-3 pb-3">Are you sure, you want to {{statusText}}?</div>
            <div class="popup-line"></div>
          </div>
        </div>
        <div class="submit col-12 d-flex justify-content-end ">
          <div class="pr-3">
            <button type="button " class="cancel-button pt-3" (click)="modal.close('Save click');onCancel()"><span
                class="cancel">Cancel</span></button>
          </div>
          <button type="button " class="add-button" (click)="toggleBooking();modal.close('Save click')"><span
              class="add">Yes</span></button>
        </div>
      </div>
    </ng-template>